import React from 'react';

export function EditTimerIcon(props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			aria-hidden='true'
			fill='none'
			focusable='false'
			height='1em'
			role='presentation'
			viewBox='0 0 20 20'
			width='1em'
			{...props}
		>
			<path
				d='M11.05 3.00002L4.20835 10.2417C3.95002 10.5167 3.70002 11.0584 3.65002 11.4334L3.34169 14.1334C3.23335 15.1084 3.93335 15.775 4.90002 15.6084L7.58335 15.15C7.95835 15.0834 8.48335 14.8084 8.74168 14.525L15.5834 7.28335C16.7667 6.03335 17.3 4.60835 15.4583 2.86668C13.625 1.14168 12.2334 1.75002 11.05 3.00002Z'
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeMiterlimit={10}
				strokeWidth={1.5}
			/>
			<path
				d='M9.90833 4.20831C10.2667 6.50831 12.1333 8.26665 14.45 8.49998'
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeMiterlimit={10}
				strokeWidth={1.5}
			/>
			<path
				d='M2.5 18.3333H17.5'
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeMiterlimit={10}
				strokeWidth={1.5}
			/>
		</svg>
	);
}
